import React from "react";

export const dataQuestions = [
    {
        idQuestion: 1,
        titleQuestion: "¿Puedo llevar mis empaques a cualquier Servientrega?",
        answerQuestion: (
            <span>
                No, existe una lista de Servientregas autorizados que puedes ver <a className="f-packaging-delivery-section-6__container-question__answer-link" href="https://www.nosotrasonline.com.co/mis-puntos/entrega-empaques/" target="_blank"> aquí</a> 
            </span>
        ),
    },
    {
        idQuestion: 2,
        titleQuestion: "¿Enviar mis empaques es gratis?",
        answerQuestion: "Si envías tus empaques desde los Servientregas autorizados, el envío es completamente gratis. Sin embargo, si no vives cerca a uno, deberás enviar tus empaques a un Servientrega autorizado, y ese envío sí correrá por tu cuenta.",
    },
    {
        idQuestion: 3,
        titleQuestion: "¿Cuántos empaques puedo enviar por sobre?",
        answerQuestion: (
            <span>
                Debes enviar <b>mínimo</b> 10 empaques en cada sobre. Si tienes más empaques para enviar, puedes hacerlo en el mismo sobre.
            </span>
        ),
    },
    {
        idQuestion: 4,
        titleQuestion: "¿Ahora todos los empaques solo me dan 20 puntos?",
        answerQuestion: "No, cada producto te otorga una cantidad de puntos diferente, que verás en tu banco de puntos una vez inscribas las claves por medio de NosotrasOnline. Los puntos por ayudar al planeta son adicionales y serán adicionados a tu banco de puntos, una vez recibamos los empaques que envías por Servientrega.",
    },
    {
        idQuestion: 5,
        titleQuestion: "¿Puedo enviar los empaques que usé para redimir un premio en la e-store?",
        answerQuestion: "Sí, una vez hayas hecho el proceso de redención: escoger el premio, llenar el formulario de redención, escribir a la línea de whatsapp autorizada, y enviar las fotos de esos empaques a ese Whatsapp, tus sobres quedan libres para enviar por Servientrega para ser reciclados por Nosotras.",
    },
    {
        idQuestion: 6,
        titleQuestion: "¿Si llevo mis empaques a Servientrega, reclamo allí los puntos?",
        answerQuestion: "No, tus puntos por ayudar al planeta serán otorgados alrededor de 20 días después de enviar tus empaques y ser verificados por Nosotras. En Servientrega no recibirás ningún premio de Nosotras.",
    },
    {
        idQuestion: 7,
        titleQuestion: "¿Cuántos puntos recibo por mis empaques?",
        answerQuestion: "Al enviar 10 empaques ganas 20 puntos. Por cada empaque adicional, ganarás 2 puntos más.",
    },
    {
        idQuestion: 8,
        titleQuestion: "¿Los empaques individuales me dan puntos?",
        answerQuestion: "No, ni los empaques individuales ni los empaques de muestras gratis te otorgarán puntos (aunque si quieres los puedes enviar). Los únicos empaques que te darán puntos son las cajas, tarros y bolsas de los productos comprados.",
    },
    {
        idQuestion: 9,
        titleQuestion: "¿Qué debo escribir en el sobre?",
        answerQuestion: (
            <span>
                En el exterior del sobre debes escribir: dirigido al Programa de puntos Nosotras. Además de tus datos: nombres y apellidos completos, teléfono o celular de contacto y el correo electrónico con el que ingresas a NosotrasOnline.com. En caso de no estar registrada en NosotrasOnline, regístrate haciendo clic <a className="f-packaging-delivery-section-6__container-question__answer-link" href="https://www.nosotrasonline.com.co/registro/fecha-de-nacimiento" target="_blank"> aquí</a>
            </span>
        ),
    },
    {
        idQuestion: 10,
        titleQuestion: "¿Qué debo hacer con los empaques cuando gano un concurso?",
        answerQuestion: "Cuando ganas un concurso redimiendo puntos que te dieron tus empaques, se te va a exigir enviarlos para que el premio te sea entregado. En este caso SOLO deberás enviar los empaques que te dieron los puntos con los que participaste en la actividad sean 3 o 30. Por ejemplo, si redimiste 400 puntos para participar en un juego y ganaste, debes enviar los empaques que te dieron esos 400 puntos.",
    },
];